import { mutate } from 'swr';

import { getCurrentLanguage } from '~/localization';

import {
  getCustomEmployeePositionFieldAttributes,
  getCustomEmployeePositionFieldLanguages,
  getCustomEmployeePositionFields,
} from '.';

export const prefetchCustomPosition = (empId: string) => {
  const currentLanguage = getCurrentLanguage();
  mutate(['customEmployeePositionFields', empId], () =>
    getCustomEmployeePositionFields(empId),
  );
  mutate('customEmployeePositionFieldsFieldAttributesPosition', () =>
    getCustomEmployeePositionFieldAttributes(),
  );
  mutate(['customEmployeePositionFieldLanguages', currentLanguage], () =>
    getCustomEmployeePositionFieldLanguages(currentLanguage),
  );
};
